import { render } from "./AuthSocial.vue?vue&type=template&id=98c9ee5e&scoped=true"
import script from "./AuthSocial.vue?vue&type=script&lang=js"
export * from "./AuthSocial.vue?vue&type=script&lang=js"

import "./AuthSocial.vue?vue&type=style&index=0&id=98c9ee5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c9ee5e"]])

export default __exports__